module.exports = __webpack_public_path__ + "img/img_service_hover.346df617.svg";